/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    sentimentScores: {},
  },
  getters: {
    sentimentScores: (state) => state.sentimentScores,
  },
  mutations: {
    setSentimentScores(state, data) {
      const { conversationId, providerData, createdAt } = data;
      let score = null;
      if (providerData && providerData.data && providerData.data.score) {
        score = Number(providerData.data.score);
      }
      if (!state.sentimentScores[conversationId]) {
        state.sentimentScores[conversationId] = {
          createdAt,
          scores: [],
        };
      }
      if (score) {
        state.sentimentScores[conversationId].scores.push({
          score,
          createdAt,
        });
      }
    },
    cleanSentimentScores(state) {
      const sentimentScores = { ...state.sentimentScores };
      const currentTimeValue = moment().utc().valueOf();
      const filteredConversations = [];
      Object.keys(sentimentScores).forEach(conversationId => {
        const { createdAt } = sentimentScores[conversationId];
        const duration = moment(createdAt).diff(moment(currentTimeValue), 'days');
        if (duration > 30) {
          filteredConversations.push(conversationId);
        }
      });
      filteredConversations.forEach(conversationId => {
        delete sentimentScores[conversationId];
      });

      state.sentimentScores = { ...sentimentScores };
    }
  },
};
